import { useEffect } from 'react';
export function useEvent(type, listener, target, disabled) {
    useEffect(() => {
        if (disabled) {
            return;
        }
        const element = target || window;
        const typedEvent = listener;
        element.addEventListener(type, typedEvent);
        return () => {
            element.removeEventListener(type, typedEvent);
        };
    }, [target, type, listener, disabled]);
}
